import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  inject,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { BottomNavbarComponent, PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { CustomNotificationQueryHandler } from '../../application/handlers';
import { CustomNotificationDTO } from '../../application/interfaces';
import { tap } from 'rxjs';
import { CustomNotificationContentComponent } from './custom-notification-content/custom-notification-content.component';

// TODO: Do przemyslenia - ComponentFactoryResolver jest deprecated od Angular 13
// Mozna zastapic przez ViewContainerRef.createComponent() bezposrednio
// Na razie zostawiamy bez zmian

@Component({
  selector: 'lib-custom-notification',
  templateUrl: './custom-notification.component.html',
  styleUrls: ['./custom-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, BottomNavbarComponent, PageLayoutComponent],
  providers: [CustomNotificationQueryHandler]
})
export class CustomNotificationComponent {
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })
  dynamicContainer!: ViewContainerRef;

  readonly open: typeof open = open;

  private readonly customNotificationQueryHandler: CustomNotificationQueryHandler =
    inject(CustomNotificationQueryHandler);
  private readonly componentFactoryResolver: ComponentFactoryResolver = inject(ComponentFactoryResolver);

  constructor() {
    this.customNotificationQueryHandler
      .getData()
      .pipe(tap((data: CustomNotificationDTO) => this.loadDynamicComponent(data.html)))
      .subscribe();
  }

  private loadDynamicComponent(html: string): void {
    this.dynamicContainer.clear();

    const factory: ComponentFactory<CustomNotificationContentComponent> =
      this.componentFactoryResolver.resolveComponentFactory(CustomNotificationContentComponent);
    const componentRef: ComponentRef<CustomNotificationContentComponent> =
      this.dynamicContainer.createComponent(factory);

    componentRef.instance.htmlContent = html;
    componentRef.changeDetectorRef.detectChanges();
  }
}
